<template>
  <div>
    <!-- 关联标签 -->
    <el-form-item label="关联政商企">
      <el-input v-model="form.supply.name" :disabled="true" class="max-w460"></el-input>
      <el-button type="primary"  @click="changeProduct()">选择归属政商企</el-button>
      <el-button   @click="deleteClick()" v-if="form.supply.name">清除政商企</el-button>
    </el-form-item>
    <!--标签选择-->
    <Supply :isproduct="isproduct" @closeDialog="closeDialogFunc"></Supply>

  </div>
</template>

<script>
import Supply from '@/components/supply/Supply';
import {mergeTable} from '@/utils/table.js';

export default {
  components: {
    /*选择商品组件*/
    Supply,
  },
  data() {
    return {
      unit: '%',
      isproduct: false,
    };
  },
  props: {
    form: Object
  },
  methods: {
    /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {
        var supply = {
          name:e.params[0].name,
          supply_id:e.params[0].supply_id,
        }
        self.form.supply = supply
        self.form.supply_id = supply.supply_id
      }
    },
    /*打开添加*/
    changeProduct() {
      
      this.isproduct = true;
    },
    /*删除标签*/
    deleteClick() {
      let self = this;
       self.form.supply = ''
        self.form.supply_id = 0
    },
  }
};
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/staff/index/part/Supply.vue